<template>
  <div class="container-wrap">
    <!-- 去掉学员信息的来源渠道设置 -->
    <!-- <div class="set-up">
      <div class="title">学员信息</div>
      <div class="item">
        来源渠道:
        <set-up-drawer dialog-type="channel">
          <span class="mwow-tag success cu-po p1">设置</span>
        </set-up-drawer>
        <div class="tips">可自由设置来源渠道，并根据门店情况自由添加；</div>
      </div>
    </div> -->
    <div class="set-up p2">
      <div class="title">学员超上设置</div>
      <div class="item">
        学员超上:
        <span class="p1">
          <el-switch
            active-color="#07d1aa"
            v-model="form.student_superupper"
            @change="handleChangeSwitch"
          ></el-switch>
        </span>
        <div class="tips">开启后，在点名时学员会出现超上课时；</div>
      </div>
      <div class="item">
        自动补扣:
        <span class="p1">
          <el-switch
            active-color="#07d1aa"
            v-model="form.automatic_make_up"
            @change="handleChangeMakeUp"
          ></el-switch>
        </span>
        <div class="tips">
          开启后，学员再次购买相同课程后，会自动补扣超上课时；
        </div>
      </div>
    </div>
    <div class="set-up p2">
      <div class="title">班级排课设置</div>
      <div class="item">
        时段设置:
        <set-up-dialog dialog-type="time">
          <span class="mwow-tag success cu-po p1">设置</span>
        </set-up-dialog>
        <div class="tips">可自由设置门店固定上课时间段；</div>
      </div>
      <div class="item">
        自由排课:
        <span class="p1">
          <el-switch
            active-color="#07d1aa"
            v-model="form.free_courses"
            @change="handleChangeFreeCourses"
          ></el-switch>
        </span>
        <div class="tips">开启后，在给班级学员排课时允许自由排课；</div>
      </div>
    </div>
    <div class="set-up p2">
      <div class="title">订单续费设置</div>
      <div class="item">
        提醒设置:
        <set-renew-drawer dialog-type="time">
          <span class="mwow-tag success cu-po p1">设置</span>
        </set-renew-drawer>
        <div class="tips">
          满足条件的学员推送续费提醒，并在续费记录中生成续费数据；
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import setUpDialog from "./setUpDialog.vue";
import {
  switchDetailApi,
  switchModifyApi,
  courseExceedTotalApi,
} from "@/api/storeManagement";
import setRenewDrawer from "./setRenewDrawer.vue";
export default {
  props: ["visible"],
  components: {
    setUpDialog,
    setRenewDrawer,
  },
  data() {
    return {
      form: {
        student_superupper: true,
        automatic_make_up: true,
        free_courses: true,
      },
      total: "",
    };
  },
  created() {
    const switchDetail = localStorage.getItem("switch_type");
    if (switchDetail !== null) {
      this.form.free_courses = JSON.parse(switchDetail).free_courses;
      this.form.student_superupper =
        JSON.parse(switchDetail).student_superupper;
      this.form.automatic_make_up = JSON.parse(switchDetail).automatic_make_up;
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        courseExceedTotalApi().then((res) => {
          if (res.error_code === 0) {
            this.total = res.data.total;
          }
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      courseExceedTotalApi().then((res) => {
        if (res.error_code === 0) {
          this.total = res.data.total;
        }
      });
    }
  },
  methods: {
    handleChangeSwitch() {
      if (this.form.student_superupper === false) {
        if (this.total !== "") {
          this.$confirm(
            `关闭超上后，点名时无法超过学员剩余课时数，且关闭后已超上的课次记录正常显示。`,
            `学员超上 - 共有 ${this.total} 个超上课时`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              this.changeSwitch("student_exceed", 2);
              this.form.student_superupper = false;
            })
            .catch(() => {
              this.form.student_superupper = true;
            });
        } else {
          this.changeSwitch("student_exceed", 2);
        }
      } else {
        this.changeSwitch("student_exceed", 1);
        this.form.student_superupper = true;
      }
      localStorage.setItem("switch_type", JSON.stringify(this.form));
    },
    handleChangeMakeUp() {
      if (this.form.automatic_make_up) {
        this.changeSwitch("student_exceed_automatic_sub", 1);
      } else {
        this.changeSwitch("student_exceed_automatic_sub", 2);
      }
      localStorage.setItem("switch_type", JSON.stringify(this.form));
    },
    handleChangeFreeCourses() {
      if (this.form.free_courses) {
        this.changeSwitch("free_arrange_lesson", 1);
      } else {
        this.changeSwitch("free_arrange_lesson", 2);
      }
      localStorage.setItem("switch_type", JSON.stringify(this.form));
    },
    changeSwitch(key, val) {
      switchModifyApi({
        key: key,
        status: val,
      })
        .then((res) => {
          if (res.error_code === 0) {
            this.$message({
              type: "success",
              message: val === 1 ? "已开启" : "已关闭",
            });
          }
        })
        .catch(() => {
          if (key === "student_exceed") {
            this.form.student_superupper = !this.form.student_superupper;
          }
          if (key === "student_exceed_automatic_sub") {
            this.form.automatic_make_up = !this.form.automatic_make_up;
          }
          if (key === "free_arrange_lesson") {
            this.form.free_courses = !this.form.free_courses;
          }
          localStorage.setItem("switch_type", JSON.stringify(this.form));
        });
    },
    beforeDestroy() {
      // 获取门店配置开关详情存储到localStorage
      switchDetailApi().then((res) => {
        if (res.error_code === 0) {
          const switchDetail = {
            free_courses: false,
            student_superupper: false,
            automatic_make_up: false,
            renew_auto_switch: false,
            renew_lesson_count: 5,
            renew_push_time: "09:00",
            new_buy_renew_time: 30,
          };
          switchDetail.free_courses = res.data.free_arrange_lesson === 1;
          switchDetail.student_superupper = res.data.student_exceed === 1;
          switchDetail.automatic_make_up =
            res.data.student_exceed_automatic_sub === 1;
          switchDetail.renew_auto_switch = res.data.renew_auto_switch === 1;
          switchDetail.renew_lesson_count = res.data.renew_lesson_count;
          switchDetail.renew_push_time = res.data.renew_push_time;
          switchDetail.new_buy_renew_time = res.data.new_buy_renew_time;
          localStorage.setItem("switch_type", JSON.stringify(switchDetail));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-wrap {
  padding: 12px;
  .set-up {
    .title {
      font-size: 14px;
    }
    .item {
      display: flex;
      align-items: center;
      margin: 12px 12px 0;
      .p1 {
        margin-left: 12px;
        margin-right: 10px;
      }
    }
  }
}
.p2 {
  margin-top: 15px;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.tips {
  color: #9e9fa0;
}
</style>
